export const hasSocialMedia = charity =>
  charity.facebook || charity.twitter || charity.instagram || charity.googlePlus
    ? true
    : false



// WEBPACK FOOTER //
// ./src/services/charity/utils.js